import React from 'react';
import {
  PlusIcon,
  UserIcon,
  BanknotesIcon,
  CheckCircleIcon
} from '@heroicons/react/24/outline';
import { CheckCircleIcon as CheckCircleSolidIcon } from '@heroicons/react/24/solid';
import { SeekerCardProps } from './types';
import { generateAvatar, formatCurrency } from './utils';

const SeekerCard: React.FC<SeekerCardProps> = ({ seeker, onClick, showViewDetails = false }) => {
  const handleClick = () => {
    onClick(seeker);
  };

  const renderStageSpecificContent = () => {
    switch (seeker.stage) {
      case 'matched':
        return (
          <div className="flex items-center space-x-1">
            <span className="inline-flex items-center text-xs text-[#2C2731] font-medium">
              <UserIcon className="w-3 h-3 mr-1" />
              {seeker.notes}
            </span>
          </div>
        );

      case 'pending_consultation': {
        const isScheduled = seeker.notes === 'Scheduled' || seeker.notes === 'Consultation scheduled';
        const isConfirmed = seeker.notes === 'Consultation confirmed';
        return (
          <div className="flex items-center space-x-1">
            <span
              className={`inline-flex items-center text-xs font-medium ${isConfirmed ? 'text-[#2C2731]' : isScheduled ? 'text-[#2C2731]/90' : 'text-[#2C2731]/70'}`}
            >
              {isConfirmed || isScheduled ? (
                <CheckCircleIcon className="w-3 h-3 mr-1" />
              ) : (
                <UserIcon className="w-3 h-3 mr-1" />
              )}
              {seeker.notes}
            </span>
          </div>
        );
      }

      case 'awaiting_package':
        return (
          <button className="w-full px-2 py-1 bg-[#2C2731] text-[#FFFCEF] text-xs font-medium rounded border border-[#2C2731] hover:bg-[#241F2A] transition-colors">
            <PlusIcon className="w-3 h-3 inline mr-1" />
            Send Package
          </button>
        );

      case 'payment_pending':
        return (
          <>
            <div className="space-y-1">
              <div className="flex items-center justify-between text-xs">
                <span className="text-[#2C2731]/80">Package:</span>
                <span className="font-medium text-[#2C2731]">{formatCurrency(seeker.amount || 0)}</span>
              </div>
              <div className="flex items-center space-x-1">
                <span className="inline-flex items-center text-xs text-[#2C2731] font-medium">
                  <BanknotesIcon className="w-3 h-3 mr-1" />
                  {seeker.notes}
                </span>
              </div>
            </div>
            {/*<button className="w-full px-2 py-1 mt-2 bg-[#2C2731] text-[#FFFCEF] text-xs font-medium rounded border border-[#2C2731] hover:bg-[#241F2A] transition-colors">
              Send Client
            </button>*/}
          </>
        );

      case 'active_clients':
        return (
          <div className="space-y-1">
            <div className="flex items-center justify-between text-xs">
              <span className="text-[#2C2731]/80">Total:</span>
              <span className="font-medium text-[#2C2731]">{formatCurrency(seeker.amount || 0)}</span>
            </div>
            <div className="flex items-center space-x-1">
              <span className="inline-flex items-center text-xs text-[#2C2731] font-medium">
                <CheckCircleSolidIcon className="w-3 h-3 mr-1" />
                {seeker.notes}
              </span>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div
      className="p-3 bg-[#FFFCEF] text-[#2C2731] rounded-lg border border-[#2C2731] cursor-pointer hover:bg-[#F3EBCD] transition-colors"
      onClick={handleClick}
    >
      <div className="flex items-center space-x-2 mb-2">
        {generateAvatar(seeker.name)}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-[#2C2731] truncate ph-mask">{seeker.name}</p>
          <p className="text-xs text-[#2C2731]/70 truncate">{seeker.title}</p>
        </div>
      </div>
      <p className="text-xs text-[#2C2731]/80 mb-2">{seeker.lastActivity}</p>
      {renderStageSpecificContent()}
    </div>
  );
};

export default SeekerCard;
